// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-block {
  width: 100%;
  height: 100%;
  text-align: center;
  overflow: auto;
}
.wrapper-block .title {
  padding: 0px 20px 5px;
  font-size: 16px;
  font-family: AppFontBold, sans-serif;
  color: var(--color-black-alt);
}
.wrapper-block .additional-info {
  padding: 0px 20px;
  font-size: 14px;
  font-family: AppFont, sans-serif;
}
.wrapper-block .block-add-pass {
  padding: 25px;
}
.wrapper-block .block-add-pass__scan {
  width: 100%;
  text-align: left;
  box-shadow: 0px 4px 10px 0px rgba(7, 38, 51, 0.1019607843);
  margin: 0px 0px 20px;
  padding: 15px 10px;
}
.wrapper-block .block-add-pass__scan h3 {
  font-size: 14px;
  font-family: AppFontSemiBold, sans-serif;
  color: var(--color-black-alt);
}
.wrapper-block .block-add-pass__checkbox-block {
  display: flex;
  align-items: center;
}
.wrapper-block .block-add-pass__checkbox-block:has(.selected) {
  margin-bottom: 10px;
}
.wrapper-block ion-button {
  width: 100%;
  --border-radius: 50px;
}

.open-section {
  max-height: 0;
  overflow: hidden;
  transition: max-height 1s;
}
.open-section.selected {
  max-height: 700px;
}
.open-section.selected-form {
  max-height: 400px;
}

ion-radio {
  --border-color: var(--ion-color-secondary);
  --border-color-checked: var(--ion-color-secondary);
  --background-checked: var(--ion-color-secondary);
  --color-checked: var(--ion-color-secondary);
  --color: var(--ion-color-secondary);
}

.wrapper-scanner {
  position: relative;
  overflow: hidden;
  width: 100%;
  margin-bottom: 28px;
  aspect-ratio: 314/270;
  border-radius: 20px;
}
.wrapper-scanner ion-img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.zx-wrapper {
  border-radius: 30px;
  overflow: hidden;
}

.zxing-scanner {
  height: 250px;
  display: flex;
}

.container {
  position: relative;
  margin: 10px 0px;
}
.container ion-label {
  position: absolute;
  left: 5px;
  top: -7px;
  padding: 0px 10px;
  background: white;
  z-index: 2;
  font-size: 11px;
  color: #cccccc;
}
.container ion-item {
  border: 1px solid #e5e5e5;
  --padding-start: 15px !important;
}

.spinner-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.spinner-wrapper ion-spinner {
  width: 100px;
  height: 100px;
}
.spinner-wrapper p {
  color: black;
  padding-top: 10px;
}

.error-block {
  width: 100%;
}

.error-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.error-wrapper ion-icon {
  width: 85px;
  height: 85px;
  margin-bottom: 20px;
}
.error-wrapper h3 {
  font-family: AppFontBold, sans-serif;
  font-size: 25px;
  margin-bottom: 25px;
}
.error-wrapper p {
  font-size: 16px;
  margin: 0;
  margin-bottom: 33px;
}
.error-wrapper ion-button {
  margin-bottom: 10px;
  font-family: AppFontBold;
}
.error-wrapper .no-btn {
  --background: white;
  color: var(--ion-color-primary-contrast);
}
.error-wrapper .no-btn span {
  text-wrap: balance;
  color: var(--ion-color-primary) !important;
}

.date-modal {
  --width: 320px;
  --height: auto;
  --border-radius: 16px;
  --backdrop-opacity: 0.4;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(28.5px);
}

/* modal inner card */
.date-modal-content {
  padding: 16px;
  background: var(--background-default);
  border-radius: var(--radius-default);
}

/* smaller datetime */
.date-modal ion-datetime {
  width: 100%;
}

/* buttons row */
.date-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
}

.loading-text {
  font-family: AppFontBold;
  font-size: 18px;
  color: var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/scan-boarding-pass/scan-boarding-pass.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AACD;AACC;EACC,qBAAA;EACA,eAAA;EACA,oCAAA;EACA,6BAAA;AACF;AACC;EACC,iBAAA;EACA,eAAA;EACA,gCAAA;AACF;AACC;EACC,aAAA;AACF;AAAE;EACC,WAAA;EACA,gBAAA;EACA,0DAAA;EAEA,oBAAA;EACA,kBAAA;AACH;AAAG;EACC,eAAA;EACA,wCAAA;EACA,6BAAA;AAEJ;AACE;EACC,aAAA;EACA,mBAAA;AACH;AAAG;EACC,mBAAA;AAEJ;AAEC;EACC,WAAA;EACA,qBAAA;AAAF;;AAGA;EACC,aAAA;EACA,gBAAA;EAEA,yBAAA;AADD;AAGC;EACC,iBAAA;AADF;AAGC;EACC,iBAAA;AADF;;AAKA;EACC,0CAAA;EACA,kDAAA;EACA,gDAAA;EACA,2CAAA;EACA,mCAAA;AAFD;;AAKA;EACC,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AAFD;AAIC;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAFF;;AAMA;EACC,mBAAA;EACA,gBAAA;AAHD;;AAKA;EACC,aAAA;EACA,aAAA;AAFD;;AAIA;EACC,kBAAA;EAgBA,gBAAA;AAhBD;AACC;EACC,kBAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,UAAA;EAEA,eAAA;EACA,cAAA;AAAF;AAEC;EACC,yBAAA;EACA,gCAAA;AAAF;;AAIA;EACC,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADD;AAEC;EACC,YAAA;EACA,aAAA;AAAF;AAEC;EACC,YAAA;EACA,iBAAA;AAAF;;AAGA;EACC,WAAA;AAAD;;AAEA;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACD;AAAC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;AAEF;AAAC;EACC,oCAAA;EACA,eAAA;EACA,mBAAA;AAEF;AAAC;EACC,eAAA;EACA,SAAA;EACA,mBAAA;AAEF;AAAC;EACC,mBAAA;EACA,wBAAA;AAEF;AAAC;EACC,mBAAA;EACA,wCAAA;AAEF;AADE;EACC,kBAAA;EACA,0CAAA;AAGH;;AAEA;EACC,cAAA;EACA,cAAA;EACA,qBAAA;EACA,uBAAA;EAEA,mBAAA;EACA,uBAAA;EAEA,6BAAA;AADD;;AAIA,qBAAA;AACA;EACC,aAAA;EACA,qCAAA;EACA,oCAAA;AADD;;AAIA,qBAAA;AACA;EACC,WAAA;AADD;;AAIA,gBAAA;AACA;EACC,aAAA;EACA,yBAAA;EACA,QAAA;EACA,gBAAA;AADD;;AAIA;EACC,wBAAA;EACA,eAAA;EACA,+BAAA;AADD","sourcesContent":[".wrapper-block {\n\twidth: 100%;\n\theight: 100%;\n\ttext-align: center;\n\toverflow: auto;\n\n\t.title {\n\t\tpadding: 0px 20px 5px;\n\t\tfont-size: 16px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tcolor: var(--color-black-alt);\n\t}\n\t.additional-info {\n\t\tpadding: 0px 20px;\n\t\tfont-size: 14px;\n\t\tfont-family: AppFont, sans-serif;\n\t}\n\t.block-add-pass {\n\t\tpadding: 25px;\n\t\t&__scan {\n\t\t\twidth: 100%;\n\t\t\ttext-align: left;\n\t\t\tbox-shadow: 0px 4px 10px 0px #0726331a;\n\n\t\t\tmargin: 0px 0px 20px;\n\t\t\tpadding: 15px 10px;\n\t\t\th3 {\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-family: AppFontSemiBold, sans-serif;\n\t\t\t\tcolor: var(--color-black-alt);\n\t\t\t}\n\t\t}\n\t\t&__checkbox-block {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\t&:has(.selected) {\n\t\t\t\tmargin-bottom: 10px;\n\t\t\t}\n\t\t}\n\t}\n\tion-button {\n\t\twidth: 100%;\n\t\t--border-radius: 50px;\n\t}\n}\n.open-section {\n\tmax-height: 0;\n\toverflow: hidden;\n\t// transition: max-height 0.5s ;\n\ttransition: max-height 1s;\n\n\t&.selected {\n\t\tmax-height: 700px;\n\t}\n\t&.selected-form {\n\t\tmax-height: 400px;\n\t}\n}\n\nion-radio {\n\t--border-color: var(--ion-color-secondary);\n\t--border-color-checked: var(--ion-color-secondary);\n\t--background-checked: var(--ion-color-secondary);\n\t--color-checked: var(--ion-color-secondary);\n\t--color: var(--ion-color-secondary);\n}\n\n.wrapper-scanner {\n\tposition: relative;\n\toverflow: hidden;\n\twidth: 100%;\n\tmargin-bottom: 28px;\n\taspect-ratio: 314 / 270;\n\tborder-radius: 20px;\n\n\tion-img {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tobject-fit: fill;\n\t}\n}\n\n.zx-wrapper {\n\tborder-radius: 30px;\n\toverflow: hidden;\n}\n.zxing-scanner {\n\theight: 250px;\n\tdisplay: flex;\n}\n.container {\n\tposition: relative;\n\tion-label {\n\t\tposition: absolute;\n\t\tleft: 5px;\n\t\ttop: -7px;\n\t\tpadding: 0px 10px;\n\t\tbackground: white;\n\t\tz-index: 2;\n\n\t\tfont-size: 11px;\n\t\tcolor: #cccccc;\n\t}\n\tion-item {\n\t\tborder: 1px solid #e5e5e5;\n\t\t--padding-start: 15px !important;\n\t}\n\tmargin: 10px 0px;\n}\n.spinner-wrapper {\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tion-spinner {\n\t\twidth: 100px;\n\t\theight: 100px;\n\t}\n\tp {\n\t\tcolor: black;\n\t\tpadding-top: 10px;\n\t}\n}\n.error-block {\n\twidth: 100%;\n}\n.error-wrapper {\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 20px;\n\tion-icon {\n\t\twidth: 85px;\n\t\theight: 85px;\n\t\tmargin-bottom: 20px;\n\t}\n\th3 {\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tfont-size: 25px;\n\t\tmargin-bottom: 25px;\n\t}\n\tp {\n\t\tfont-size: 16px;\n\t\tmargin: 0;\n\t\tmargin-bottom: 33px;\n\t}\n\tion-button {\n\t\tmargin-bottom: 10px;\n\t\tfont-family: AppFontBold;\n\t}\n\t.no-btn {\n\t\t--background: white;\n\t\tcolor: var(--ion-color-primary-contrast);\n\t\tspan {\n\t\t\ttext-wrap: balance;\n\t\t\tcolor: var(--ion-color-primary) !important;\n\t\t}\n\t}\n}\n\n.date-modal {\n\t--width: 320px;\n\t--height: auto;\n\t--border-radius: 16px;\n\t--backdrop-opacity: 0.4;\n\n\talign-items: center;\n\tjustify-content: center;\n\n\tbackdrop-filter: blur(28.5px);\n}\n\n/* modal inner card */\n.date-modal-content {\n\tpadding: 16px;\n\tbackground: var(--background-default);\n\tborder-radius: var(--radius-default);\n}\n\n/* smaller datetime */\n.date-modal ion-datetime {\n\twidth: 100%;\n}\n\n/* buttons row */\n.date-actions {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tgap: 8px;\n\tmargin-top: 12px;\n}\n\n.loading-text {\n\tfont-family: AppFontBold;\n\tfont-size: 18px;\n\tcolor: var(--ion-color-primary);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
